<template>
  <section class="form-sect">
    <div v-if="title" class="title">
      <h3>{{ title }}</h3>
      <div v-if="sub" class="sub">
        {{ sub }}
      </div>
    </div>
    <slot></slot>
  </section>
</template>

<script>
export default {
  props: ['sub', 'title'],
}
</script>

<style lang="scss">
@import '~style/variables';

section.form-sect {
  border-bottom: 1px solid $c-border;
  padding: 1rem;
  > .title {
    margin-bottom: 1rem;
    h3 {
      color: $c-text-mid;
      margin-bottom: 0;
    }
    .sub {
      color: $c-mid;
      font-size: $h5;
      line-height: 1rem;
    }
  }
  p {
    margin: 1rem 0;
  }
  @media screen and (min-width: $res-md) {
    padding: 2rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/components/globals/FormSect.vue